/// <reference types="facebook-js-sdk" />
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@env-properties/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}


if(environment.debugMode == false){
  if(window){
     window.console.log  = function(){
      // Don't log anything.
    };
    window.console.error  = function(){
      // Don't log anything.
    };
    window.console.warn  = function(){
      // Don't log anything.
    };
    window.console.time  = function(){
      // Don't log anything.
    };
    window.console.timeEnd  = function(){
      // Don't log anything.
    };
    window.console.trace  = function(){
      // Don't log anything.
    };
    window.console.group  = function(){
      // Don't log anything.
    };
  }
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
